module.exports = __webpack_public_path__ + "static/img/vf_home_v3.c5fe58f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/vf_home_v3.jpg
// module id = 6IkL
// module chunks = 6